import { FormRow as LongFormRow } from 'framework/ui/layout';
import { useEffect } from 'react';
import { TextInput, DateInput, DefaultInputPropTypes, useInputHelper } from 'framework/form';
import { getLastSource } from 'framework/utils';

interface RelationInputProps extends DefaultInputPropTypes<any> {
  relationInput: React.ElementType;
}

const RelationInput = ({ relationInput: RelationComponent, className, ...props }: RelationInputProps) => {
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);

  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});
  const familyMember = getValue() || {
    name: {},
  };
  const source = getSource();

  const nameOnChangeCallback = (value: { [x: string]: any }) => {
    rawOnChangeCallback({
      [source]: {
        ...familyMember,
        name: {
          ...familyMember.name,
          ...getLastSource(value),
        },
      },
    });
  };

  const onChangeCallback = (value: { [x: string]: any }) => {
    rawOnChangeCallback({
      [source]: {
        ...familyMember,
        ...getLastSource(value),
      },
    });
  };

  useEffect(() => {
    if (!getValue()) {
      rawOnChangeCallback({
        [source]: { name: {} },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LongFormRow
      sx={theme => ({
        flexGrow: 1,
        [theme.breakpoints.up('xl')]: {
          '& > div': {
            flexBasis: '33.3333%',
            maxWidth: '33.3333%',
          },
        },
      })}
    >
      <TextInput
        source={`${source}.name.firstName`}
        value={familyMember.name.firstName}
        onChangeCallback={nameOnChangeCallback}
        className={className}
      />
      <TextInput
        source={`${source}.name.middleName`}
        value={familyMember.name.middleName}
        onChangeCallback={nameOnChangeCallback}
        className={className}
      />
      <TextInput
        source={`${source}.name.lastName`}
        value={familyMember.name.lastName}
        onChangeCallback={nameOnChangeCallback}
        className={className}
      />
      <RelationComponent
        source={`${source}.relation`}
        label="Relation Degree"
        value={familyMember.relation}
        onChangeCallback={onChangeCallback}
        className={className}
      />
      <DateInput
        source={`${source}.dateOfBirth`}
        value={familyMember.dateOfBirth}
        label="Date of Birth"
        onChangeCallback={onChangeCallback}
        className={className}
      />
    </LongFormRow>
  );
};

export default RelationInput;
